import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { environment } from '../../environments/environment'
import { AppService } from '../../service/app.service'
import { AtomModule } from '../../atom/atom.module'

@Component({
  selector: 'app-discord-signin',
  templateUrl: './discord-signin.component.html',
  styleUrl: './discord-signin.component.less',
  standalone: true,
  imports: [AtomModule]
})
export class DiscordSigninComponent implements OnInit{
  @Output() registerClick: EventEmitter<void> = new EventEmitter()
  @Output() token: EventEmitter<string> = new EventEmitter()
  @Output() buttonClick: EventEmitter<void> = new EventEmitter()

  @Input() pluginName = ''
  @Input() text = ''
  @Input() page = ''

  isBrowser: boolean

  constructor(private appService: AppService) {}

  ngOnInit(): void {
    this.appService.isBrowser$.subscribe((state) => {
      this.isBrowser = state
    })
  }
  

  login() {
    this.buttonClick.emit()
    console.log('discord login')

    const clientId = environment.DISCORD_CLIENT_ID
    const redirectUri = encodeURIComponent(
      window.location.origin + `/${this.page}?provider=discord`
    )
    const scopes = encodeURIComponent('identify email')
    
    console.log(`redirectURI: ${redirectUri}`)
    
    const discordAuthUrl = `https://discord.com/api/oauth2/authorize?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=code&scope=${scopes}`

    // Redirect the user to Discord's OAuth2 authorization page
    window.location.href = discordAuthUrl
  }
}
